const state = {
	configuratorData: {
		PrimaryColor: '#000000',
		SecondaryColor: '#000000',
	},
	products: [],
	extras: [],
	upsells: [],
	testimonials: [],
	order: {
		details: {},
		product: '',
		extras: [],
		upsells: [],
	},
};

export { state as default };
